import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  locationBasedSalesPerMonth: [],
  addData: {},
  sorted: [],
  saleTypes: [],
  dailySalesTargets: {
    data: {}, // { "2026-02-01": 5000 }
    totalTargetPerMonth: 0, 
    time: null,
  },
  addDailySalesTargetsData: {
    data: {}, // { "2026-02-01": 5000 }
    time: null,
  },
};

const slice = createSlice({
  name: 'Sales',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET SaleManagement
    getAllSaleTypesSuccess(state, action) {
      state.saleTypes = action.payload.data;
    },
    // GET SaleManagement
    getSalesSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET SaleManagement
    locationBasedSalesPerMonthSuccess(state, action) {
      state.locationBasedSalesPerMonth = action.payload.data;
    },

    addOrUpdateSales(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
    // ---------------- DAILY SALES TARGETS ----------------
    getDailySalesTargetsSuccess(state, action) {
      
      state.dailySalesTargets = {
        data: action.payload.data, // data structure is different with global and others
        totalTargetPerMonth: action.payload.totalTargetPerMonth,
        time: moment.now().toString(),
      };
    },

    addOrUpdateDailySalesTargetsSuccess(state, action) {
      state.addDailySalesTargetsData = {
        data: action.payload,
        time: moment.now().toString(),
      };
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllSaleTypes() {
  return async () => {
    try {
      const response = await get(`allSaleTypes`);
      if (response.status) {
        dispatch(slice.actions.getAllSaleTypesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getLocationBasedSalesPerMonth(year, month) {
  return async () => {
    try {
      const response = await get(`locationBasedSalesPerMonth?year=${year}&month=${month}`);
      if (response.status) {
        dispatch(slice.actions.locationBasedSalesPerMonthSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addSale(body) {
  return async () => {
    try {
      const response = await post(`Sale`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSales(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateSale(body) {
  return async () => {
    try {
      const response = await put(`Sale`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSales(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteSale(body) {
  return async () => {
    try {
      const response = await deleteMethod(`sale`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateSales(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getDailySalesTargets(year, month, locationId) {
  return async (dispatch) => {
    try {
      const response = await get(`dailySalesTarget?year=${year}&month=${month}&locationId=${locationId}`);

      if (response.status) {
        dispatch(slice.actions.getDailySalesTargetsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


// ----------------------------------------------------------------------

export function addOrUpdateDailySalesTargets(body) {
  return async (dispatch) => {
    try {
      const response = await post('dailySalesTarget', body);

      if (response.status) {
        dispatch(slice.actions.addOrUpdateDailySalesTargetsSuccess(response.data));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



